// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607212018/js/" + chunkId + "." + {"44":"945ca6de","225":"c27cfd53","481":"8e0e7f80","486":"aab06b6b","770":"8726cb10"}[chunkId] + ".0.5274558915416089.chunk.js";
};